import * as React from 'react';
import { setLogLevel } from 'livekit-client';
import { useRoomContext } from '@livekit/components-react';
export const useDebugMode = ({ logLevel } = {}) => {
    const room = useRoomContext();
    React.useEffect(() => {
        setLogLevel(logLevel !== null && logLevel !== void 0 ? logLevel : 'debug');
        // @ts-expect-error
        window.__lk_room = room;
        return () => {
            // @ts-expect-error
            window.__lk_room = undefined;
        };
    }, [room, logLevel]);
};
